import { useMutation } from '@tanstack/react-query'
import { GENERATE_DOWNLOAD_LINK } from '../data/generate-download-link'
import {
  GenerateDownloadLinkMutationMutation,
  GenerateDownloadLinkMutationMutationVariables
} from '@/core/types/graphql'
import { request } from '../../../core/utils/request'

export const useGenerateDownloadLink = () => {
  const generateDownloadLink = useMutation({
    mutationKey: ['generateDownloadLink'],
    mutationFn: async ({
      variables
    }: {
      variables: GenerateDownloadLinkMutationMutationVariables
    }) =>
      await request<
        GenerateDownloadLinkMutationMutation,
        GenerateDownloadLinkMutationMutationVariables
      >(GENERATE_DOWNLOAD_LINK, { variables })
  })

  return {
    generateDownloadLink: generateDownloadLink.mutateAsync
  }
}
